
import React from 'react';
import { useLocation } from 'react-router-dom';
import SupportWidget from './SupportWidget';

const ConditionalSupportWidget: React.FC = () => {
  const location = useLocation();
  
  // Liste des routes où le support ne doit pas apparaître
  const excludedRoutes = [
    '/admin',
    '/admin/',
    '/admin/dashboard',
    '/admin/users',
    '/admin/list-promotion',
    '/admin/add-promotion',
    '/admin/edit-promotion',
    '/login',
    '/register',
    // Ajoutez toutes vos routes admin ici
  ];

  const shouldShowSupport = !excludedRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  if (!shouldShowSupport) {
    return null;
  }

  return <SupportWidget />;
};

export default ConditionalSupportWidget;